export enum StatusEnum {
  /** 新建 */
  CREATING = 0,
  /** 资料审核中 */
  VERIFYING = 1,
  /** 审核通过 */
  SUCCESS = 2,
  /** 审核不通过 */
  ERROR = 3,
  /** 人工介入审核 */
  MANUAL = 99,
}

export enum PRIVACY_CONFIG_TYPE {
  /** 用户协议 */
  userAgreement = 'userAgreement',
  /** 隐私协议 */
  privacyPolicy = 'privacyPolicy',
}
